import { FormControl } from "@angular/forms";
import { environment } from "../../environments/environment";
import moment from "moment";

export const emailPattern = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z.]{2,6}$/;
export const mobilePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

export function password_validation(control: FormControl) {
	let password: any = control.value;
	if (password == null || password == undefined) {
		password = "";
	}
	let errObj: any = {};
	if (password.length < 8) {
		errObj.minlengtherror = true;
	}
	const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	if (!specialChars.test(password)) {
		errObj.specialcharerror = true;
	}
	const upper = /[A-Z]/;
	const lower = /[a-z]/;
	const digit = /\d/;
	if (!upper.test(password)) {
		errObj.uppercaseerror = true;
	}
	if (!lower.test(password)) {
		errObj.lowercaseerror = true;
	}
	if (!digit.test(password)) {
		errObj.digiterror = true;
	}
	return errObj ? errObj : null;
}

export function getDeviceId(): string {
	const key = 'hc_device_id';
	let deviceId = localStorage.getItem(key);
	if (!deviceId) {
		deviceId = crypto.randomUUID();
		localStorage.setItem(key, deviceId);
	}
	return deviceId;
}

export const iconList: any = [
	{ type: "xlsx", icon: "file-excel-o" },
	{ type: "xls", icon: "file-excel-o" },
	{ type: "xlsm", icon: "file-excel-o" },
	{ type: "csv", icon: "file-excel-o" },
	{ type: "doc", icon: "file-word-o" },
	{ type: "docx", icon: "file-word-o" },
	{ type: "docm", icon: "file-word-o" },
	{ type: "mp4", icon: "file-video-o" },
	{ type: "avi", icon: "file-video-o" },
	{ type: "pdf", icon: "file-pdf-o" },
	{ type: "jpg", icon: "picture-o" },
	{ type: "jpeg", icon: "picture-o" },
	{ type: "png", icon: "picture-o" },
	{ type: "gif", icon: "picture-o" },
	{ type: "jfif", icon: "picture-o" },
	{ type: "zip", icon: "file-archive-o" },
	{ type: "rar", icon: "file-archive-o" },
	{ type: "mp3", icon: "file-audio-o" },
	{ type: "webm", icon: "file-audio-o" },
	{ type: "txt", icon: "file-text" }
];

export function isImage(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
	} catch (error) {
		return false;
	}
}

export function isPdf(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "pdf";
	} catch (error) {
		return false;
	}
}

export function formatTimestamp(timestamp_str: any): string {
	if (!timestamp_str) {
		return '';
	}
	let date: any;
	timestamp_str = moment(timestamp_str)
	if (timestamp_str.toDate) {
		date = timestamp_str.toDate();
	} else {
		date = new Date(timestamp_str);
	}
	if (isNaN(date.getTime())) {
		return '';
	}
	const now = new Date();
	const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
	/* 1. Future dates handling (optional safeguard) */
	if (diffInSeconds < 0) {
		return 'Just now';
	}
	/* 2. Recent relative time (Seconds, Minutes, Hours) */
	if (diffInSeconds < 60) {
		return diffInSeconds <= 1 ? 'Just now' : `${diffInSeconds} sec ago`;
	}
	const diffInMinutes = Math.floor(diffInSeconds / 60);
	if (diffInMinutes < 60) {
		return diffInMinutes === 1 ? '1 min ago' : `${diffInMinutes} mins ago`;
	}
	const diffInHours = Math.floor(diffInMinutes / 60);
	if (diffInHours < 24) {
		/* Optional: Check if it's still "Today" before using "X hours ago" */
		const today = new Date();
		if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()) {
			return diffInHours === 1 ? '1 hour ago' : `${diffInHours} hours ago`;
		}
	}
	/* Helper to format time as "12:00 PM" */
	const timeString = date.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	});

	/* 3. Calendar Day-based difference (Today/Yesterday/Days ago) */
	const todayZero = new Date();
	todayZero.setHours(0, 0, 0, 0);

	const compareDateZero = new Date(date);
	compareDateZero.setHours(0, 0, 0, 0);

	const diffDays = Math.floor((todayZero.getTime() - compareDateZero.getTime()) / (1000 * 60 * 60 * 24));

	if (diffDays === 0) {
		return `Today ${timeString}`; /* Fallback for Today if it crossed the 24h threshold but is calendar today */
	}
	if (diffDays === 1) {
		return `Yesterday ${timeString}`;
	}
	if (diffDays > 1 && diffDays < 7) {
		return `${diffDays} days ago`; /* e.g., "2 days ago" */
	}

	/* 4. Older than a week */
	return date.toLocaleDateString('en-GB', {
		day: '2-digit',
		month: 'short',
		year: 'numeric'
	});
}